export default {
  paged: {
    select: 'id,created,year,month,source,provider,family,totalTokens,finalPrice',
    searchSelect: ['family'],
    expand: {
      model: {
        select: 'name',
      },
      processInstance: {
        select: 'name',
      },
      chatThread: {
        select: 'id,number,name',
      },
    },
  },
  itemDetail: {
    select:
      'id,year,month,source,provider,family,inputTokens,inputTokensCache,outputTokens,totalTokens,finalPrice,billingMetric,isLongContext,created',
    expand: {
      model: {
        select: 'name',
      },
      process: {
        select: 'name',
      },
      processInstance: {
        select: 'id,name',
      },
      actionInstance: {
        select: 'config,status',
      },
      aiAgent: {
        select: 'id,name',
      },
      chatThread: {
        select: 'id,number,name',
      },
      connection: {
        select: 'name',
      },
      user: {
        select: 'id,fullName',
      },
      app: {
        select: 'name',
      },
    },
  },
};
